export default {
  en: {
    membersWrapper: {
      entityTypes: {
        entityTypeProject: 'project',
        entityTypeTeam: 'team',
        entityTypeCompany: 'company'
      },
      counter: {
        usersLimit: 'Users limit',
        usersWithAccess: 'Users with access to the',
      },
      table: {
        titles: {
          usersWithAccess: 'Users with access to the',
          teamsWithAccess: 'Teams with access to the',
          roles: 'Roles',
          accessFrom: 'Access obtained via',
          invitedBy: 'Invited by',
          creator: 'Creator'
        },
        ldap: {
          modalHeader: 'Editing a user role',
          modalEditDescription: 'Editing his role will override the LDAP sync settings',
          modalLockDescription: "When locking a user's role",
          modalCurrenRoleLockDescription: 'his current role will be locked and cannot be edited',
          modalResetDescription:
            'To reset the role to the one specified in the LDAP sync settings, you must re-sync',
          cancel: 'Cancel',
          lock: 'Lock',
          unlock: 'Unlock'
        }
      },
      tableItem: {
        roles: {
          titles: {
            baseProjectRoles: 'Base Roles',
            globalRoles: 'Global Roles',
            companyRoles: 'Company Roles'
          },
          baseRoles: {
            GUEST: 'Guest',
            REPORTER: 'Reporter',
            DEVELOPER: 'Developer',
            ADMIN: 'Administrator',
            OWNER: 'Owner'
          }
        },
        titles: {
          invitationNotAccepted: 'Invitation not accepted'
        }
      }
    }
  },
  ru: {
    membersWrapper: {
      entityTypes: {
        entityTypeProject: 'проекту',
        entityTypeTeam: 'команде',
        entityTypeCompany: 'компании'
      },
      counter: {
        usersLimit: 'Лимиты пользователей',
        usersWithAccess: 'Пользователи с доступом к',
      },
      table: {
        titles: {
          usersWithAccess: 'Пользователи с доступом к',
          teamsWithAccess: 'Команды с доступом к',
          roles: 'Роли',
          accessFrom: 'Доступ получен через',
          invitedBy: 'Приглашен пользователем',
          creator: 'Создатель'
        },
        ldap: {
          modalHeader: 'Редактирование роли пользователя',
          modalEditDescription:
            'Редактирование его роли переопределит настройки синхронизации LDAP',
          modalLockDescription: 'При блокировке роли пользователя',
          modalCurrenRoleLockDescription: 'его текущая роль будет заблокирована и нередактируема',
          modalResetDescription:
            'Для сброса роли до указанной в настройках синхронизации LDAP необходимо произвести повторную синхронизацию',
          cancel: 'Отменить',
          lock: 'Заблокировать',
          unlock: 'Разблокировать'
        }
      },
      tableItem: {
        roles: {
          titles: {
            baseProjectRoles: 'Базовые роли',
            globalRoles: 'Глобальные роли',
            companyRoles: 'Роли компании'
          },
          baseRoles: {
            GUEST: 'Гость',
            REPORTER: 'Докладчик',
            DEVELOPER: 'Разработчик',
            ADMIN: 'Администратор',
            OWNER: 'Владелец'
          }
        },
        titles: {
          invitationNotAccepted: 'Приглашение не принято'
        }
      }
    }
  }
};
